<label class="display-block full-width" [class.color-error-important]="control && (control.dirty || control.touched) && !control.valid">
    <ng-content></ng-content>
</label>
